import { useState } from "react";
import { useOpenAiGlobal } from "../use-openai-global";
import { createRoot } from "react-dom/client";
import { Document, Page, pdfjs } from "react-pdf";
import { Button } from "@openai/apps-sdk-ui/components/Button";
import { LoadingIndicator } from "@openai/apps-sdk-ui/components/Indicator";
import { ArrowDown } from "@openai/apps-sdk-ui/components/Icon";


// 引入样式（必须引入，否则文本层会错位）
import 'react-pdf/dist/Page/TextLayer.css';
import 'react-pdf/dist/Page/AnnotationLayer.css';
pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

interface UpdateOutput {
  resumePdf?: {
    file_id: string;
  };
  updateStruct?: any;
  downloadUrl?: string | null;
  finalUrl?: string | null;
  pdfDownloadRes?: any;
}

function App() {
  const toolOutput = useOpenAiGlobal("toolOutput") as UpdateOutput | null;
  const downloadUrl = toolOutput?.downloadUrl ?? null;
  const pdfDownloadRes = toolOutput?.pdfDownloadRes ?? null;

  const [numPages, setNumPages] = useState<number | null>(null);
  const [pageNumber, setPageNumber] = useState<number>(1);

  function onDocumentLoadSuccess({ numPages }: { numPages: number }) {
    setNumPages(numPages);
    setPageNumber(1);
  }

  const goToPrevPage = () => setPageNumber((prev) => Math.max(prev - 1, 1));
  const goToNextPage = () => setPageNumber((prev) => Math.min(prev + 1, numPages || 1));

  const handleDownload = () => {
    if (!downloadUrl) {
      return;
    }
    if (!pdfDownloadRes) {
      return;
    }

    if (window.openai?.openExternal) {
      window.openai.openExternal({ href: pdfDownloadRes?.result });
      return;
    }
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", padding: "20px" }}>
      {/* <h1>Resume Update</h1> */}

      {downloadUrl ? (
        <>
          <div style={{ border: "1px solid #ddd", boxShadow: "0 2px 8px rgba(0,0,0,0.1)" }}>
            <Document
              file={downloadUrl}
              onLoadSuccess={onDocumentLoadSuccess}
              onLoadError={(error) => console.error("Failed to load PDF:", error)}
            >
              <Page
                pageNumber={pageNumber}
                renderTextLayer={true}
                renderAnnotationLayer={true}
                width={600}
              />
            </Document>
          </div>
          <div style={{ marginBottom: "10px",  marginTop: "10px" }}>
            <Button
              onClick={goToPrevPage}
              disabled={pageNumber <= 1}
              color="primary"
              size="md"
              variant="solid"
            >
              Previous Page
            </Button>
            <span style={{ margin: "0 15px" }}>
              Page {pageNumber} of {numPages || "?"}
            </span>
            <Button
              onClick={goToNextPage}
              disabled={pageNumber >= (numPages || 1)}
              color="primary"
              size="md"
              variant="solid"
            >
              Next Page
            </Button>
            <Button
              onClick={handleDownload}
              color="primary"
              size="md"
              variant="solid"
              disabled={pdfDownloadRes === null}
              style={{ marginLeft: "12px" }}>
              Download PDF <ArrowDown />
            </Button>
          </div>
        </>
      ) : (
        <div className="flex items-center gap-2">
          <LoadingIndicator
            size = {20}
            strokeWidth={2}
          />
          Resume Loading...
        </div>
      )}

      {/* <pre>{JSON.stringify(updateStruct, null, 2)}</pre> */}
    </div>
  );
}

const root = document.getElementById("update-resume-root");

if (root) {
  createRoot(root).render(<App />);
}
